// extracted by mini-css-extract-plugin
module.exports = {"LabNotebookContentContainer":"LabNotebook_LabNotebookContentContainer__3t2-T","LabNotebookDetailsContainer":"LabNotebook_LabNotebookDetailsContainer__3C90_"};